import { Outlet } from 'react-router-dom';

import { Providers } from '@/components/providers';

import { AntdProvider } from './antd-provider';

export function RootLayout() {
  return (
    <AntdProvider>
      <Providers>
        <Outlet />
      </Providers>
    </AntdProvider>
  );
}
